<template>
  <el-row>
    <el-tabs v-model="activeName"
             type="card"
             @tab-click="handleClick">
      <el-tab-pane label="待处理"
                   name="0"></el-tab-pane>
      <el-tab-pane label="已处理"
                   name="1"></el-tab-pane>
    </el-tabs>

    <el-card shadow="none"
             class="form-card mb-15">
      <el-form :inline="true"
               :model="searchForm"
               ref="search_form"
               class="search-form">

        <el-form-item label="记录ID:"
                      prop="sf_alarm_record_id">
          <el-input v-model.trim="searchForm.sf_alarm_record_id"
                    placeholder="记录ID"></el-input>
        </el-form-item>

        <el-form-item label="房间名称:"
                      prop="sf_room_name">
          <el-input v-model.trim="searchForm.sf_room_name"
                    placeholder="房间名称"></el-input>
        </el-form-item>

        <!-- 
        <el-form-item label="开门结果:"
                      prop="open_result">
          <el-select v-model="searchForm.open_result"
                     placeholder="开门结果">
            <el-option label="全部"
                       value=""></el-option>
            <el-option label="正常"
                       value="1"></el-option>
            <el-option label="非法"
                       value="2"></el-option>
          </el-select>
        </el-form-item>
        -->

        <el-form-item label="设备编号:"
                      prop="sf_device_sn">
          <el-input v-model.trim="searchForm.sf_device_sn"
                    placeholder="设备编号"></el-input>
        </el-form-item>

        <el-form-item label="设备名称:"
                      prop="sf_device_name">
          <el-input v-model.trim="searchForm.sf_device_name"
                    placeholder="设备名称"></el-input>
        </el-form-item>

        <el-form-item>
          <el-button type="primary"
                     icon="el-icon-search"
                     @click="searchSubmit('search_form')">查询
          </el-button>
          <el-button icon="el-icon-refresh"
                     @click="resetForm('search_form')">重置
          </el-button>
        </el-form-item>
      </el-form>
    </el-card>
    <el-row>

    </el-row>
    <el-card shadow="none"
             class="mt-15">
      <el-table max-height="575"
                ref="multipleTable"
                :data="tableData"
                @selection-change="handleSelectionChange">
        <el-table-column type="selection"
                         width="50"> </el-table-column>
        <el-table-column v-for="(item, index) in tableTitle"
                         :fixed="item.fixed"
                         :key="index"
                         :label="item.name"
                         :prop="item.prop"
                         :min-width="item.width"
                         :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column fixed="right"
                         :label="(activeName === '0' ? '操作':'处理时间')"
                         :width="(activeName === '0' ? '100':'160')">
          <template slot-scope="scope">
            <el-link class="mr-5"
                     v-if="(activeName === '1')"
                     :underline="false"
                     type='primary'>{{scope.row.alarm_con_dt}} </el-link>
            <el-button v-if="(activeName === '0')"
                       size="mini"
                       type="primary"
                       :disabled="!hasPermConfirm"
                       @click="handleConfirm(scope.row)">处理</el-button>
          </template>
        </el-table-column>
      </el-table>
      <Pagination :total="pagination.total"
                  :pageSize="pagination.perPage"
                  @handleSizeChange="handleSizeChange"
                  @handleCurrent="handleCurrentChange"></Pagination>
    </el-card>
  </el-row>
</template>

<script>
import fetch from '@/common/api'
import Pagination from '@/components/pagination/Pagination'

export default {
  components: { Pagination },
  data() {
    return {
      activeName: '0',
      hasPermConfirm: false,
      inputDescValue: '',
      areaList: [],
      searchForm: {
        sf_alarm_record_id: '',
        sf_room_name: '',
        sf_device_sn: '',
        sf_device_name: ''
      },
      tableTitle: [
        {
          prop: 'alarm_record_id',
          name: '记录ID',
          width: '100'
        },
        {
          prop: 'house_id',
          name: '房屋ID',
          width: '180'
        },
        {
          prop: 'community',
          name: '小区',
          width: '160'
        },
        {
          prop: 'building',
          name: '楼号',
          width: '100'
        },
        {
          prop: 'unit',
          name: '单元号',
          width: '100'
        },
        {
          prop: 'room',
          name: '房间名称',
          width: '120'
        },
        {
          prop: 'device_type',
          name: '设备类型',
          width: '100'
        },
        {
          prop: 'device_name',
          name: '设备名称',
          width: '160'
        },
        {
          prop: 'device_sn',
          name: '设备编号',
          width: '100'
        },
        {
          prop: 'alarm_type',
          name: '告警类型',
          width: '120'
        },
        {
          prop: 'alarm_confirm',
          name: '处理状态',
          width: '100'
        },
        {
          prop: 'alarm_desc',
          name: '处理详情',
          width: '160'
        },
        {
          prop: 'alarm_gen_dt',
          name: '告警时间',
          width: '160'
        }
      ],
      tableData: [],
      // 分页相关
      pagination: {
        total: 0,
        currentPage: 1,
        perPage: 10
      },
      // 选中数据
      multipleSelection: []
    }
  },
  created() {
    this.hasPermConfirm = fetch.hasUserPermission('/dev_alarm/confirm')
    this.getList()
  },
  methods: {
    // 获取列表
    getList() {
      const { perPage, currentPage } = this.pagination
      // const { searchForm } = this.searchForm
      // let datas = {
      //   alarm_record_id: searchForm.alarm_record_id,
      //   house_id: searchForm.house_id,
      //   room: searchForm.room,
      //   device_type: searchForm.device_type,
      //   device_sn: searchForm.device_sn,
      //   device_name: searchForm.device_name,
      //   alarm_type: searchForm.alarm_type
      // }
      fetch
        .getDevAlarmList({
          activeName: this.activeName,
          perPage: perPage,
          currentPage: currentPage,
          ...this.searchForm
        })
        .then((data) => {
          data.procData(
            data.res,
            (data) => {
              this.pagination.total = Number(data.total)
              this.tableData = data.list.map((item) => {
                item.alarm_confirm = item.alarm_confirm === '0' ? '未处理' : '已处理'
                item.device_type =
                  item.device_type === '1' ? '锁' : item.device_type === '2' ? '烟感' : '未知'
                return item
              })
            },
            (err) => {
              this.$message.error(err)
            }
          )
        })
    },
    //选项卡切换
    handleClick() {
      this.pagination.currentPage = 1
      this.getList()
    },
    // 搜索提交
    searchSubmit() {
      this.pagination.perPage = 10
      this.pagination.currentPage = 1
      this.getList()
    },
    resetForm(formName) {
      this.pagination.perPage = 10
      this.pagination.currentPage = 1
      //this.searchForm.begin_time = []
      this.$refs[formName].resetFields()
      this.getList()
    },
    // 选择变化
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    // 分页
    handleSizeChange(val) {
      this.pagination.perPage = val
      this.pagination.currentPage = 1
      this.getList()
    },
    handleCurrentChange(val) {
      this.pagination.currentPage = val
      this.getList()
    },
    // 处理
    handleConfirm(data) {
      this.inputDescValue = ''
      this.$prompt('请输入处理详情（最多200字）', '输入', {
        inputType: 'textarea',
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        // inputValidator: (value) => {
        //   console.log(value.length)
        //   if (value.length > 200) {
        //     return false
        //   }
        //   return true
        // },
        inputPattern: /^.{0,200}$/,
        //邮箱验证：  /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/,
        inputErrorMessage: '输入内容超过200字限制'
      })
        .then(({ value }) => {
          fetch
            .confirmDevAlarm({
              id: data.alarm_record_id,
              decision_id: data.decision_id,
              desc: value
            })
            .then((data) => {
              data.procData(
                data.res,
                () => {
                  this.getList()
                  this.$message.success('操作成功')
                },
                (err) => {
                  this.$message.error(err)
                }
              )
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '取消输入，告警未处理！'
          })
        })
    },
    handleSubmit() {
      console.log(this.inputDescValue)
    }
  }
}
</script>
<style>
</style>
